import React from 'react';
import { Heading6, remRhythm, greaterThan } from 'localmed-core';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { space } from 'styled-system';
import { withCustomContexts } from '../Contexts';

const IMAGE_HEIGHT = '26px';

const Image = styled('img')(
  ({ theme }) => css`
    margin-left: ${theme.space.sm};
    max-height: ${IMAGE_HEIGHT};
    vertical-align: middle;
  `
);

const PartnerDisclaimer = styled('p')(
  ({ theme }) => css`
    margin: ${remRhythm(0.25)} 0 0;
    padding: 0 ${remRhythm(0.25)};
    font-size: ${theme.fontSizes.xxs};
    opacity: 0.8;
  `,
  greaterThan(
    'md',
    css`
      margin-top: ${remRhythm(0.5)};
      padding: 0 ${remRhythm(0.5)};
    `
  )
);

const FooterLayout = styled('footer')(
  ({ theme }) => css`
    background: ${theme.colors.footerBackground};
    padding: ${theme.space.sm};
    text-align: center;
    border-top: 1px solid ${theme.colors.borderColor};
  `,
  space
);

const PartnerImage = ({ partner }) => (
  <Image src={partner.logo} alt={partner.display} height="26" />
);

function DiFooter({
  text,
  widgetSettings: { partnerData: { partner } = {}, hidePartnerLogo } = {},
}) {
  const showPartnerLogo = partner && partner.logo && !hidePartnerLogo;
  const showPartnerDisclaimer = partner && partner.widgetDisclaimer;

  const partnerLogo = showPartnerLogo && <PartnerImage partner={partner} />;
  return (
    <FooterLayout>
      <Heading6 fontSize="xxs" fontWeight={800}>
        {text || 'Powered by di.'} {partnerLogo}
      </Heading6>
      {showPartnerDisclaimer && <PartnerDisclaimer>{partner.widgetDisclaimer}</PartnerDisclaimer>}
    </FooterLayout>
  );
}

export default withCustomContexts(DiFooter);
